module.exports = __webpack_public_path__ + "img/Ka.a4414e74.png";